import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoginComponent } from "./components/login/login.component";
import { ShowDiagramComponent } from "./components/show-diagram/show-diagram.component";
import { FormComponent } from "./components/form/form.component";
import { DatatableHistorialComponent } from "./components/datatable-historial/datatable-historial.component";
import { LayoutComponent } from "./components/layout/layout.component";
import { UsuariosComponent } from "./components/usuarios/usuarios.component";
import { GrupoComponent} from "./components/grupo/grupo.component";
import { DatatableProcesosComponent} from "./components/datatable-procesos/datatable-procesos.component";
import { RolComponent} from "./components/rol/rol.component";
import { DatatableFormulariosComponent} from "./components/datatable-formularios/datatable-formularios.component";
import { authGuard } from "./guards/auth.guard";
import { FormEditComponent} from "./components/form-edit/form-edit.component";
import {IniciarProcesoComponent} from "./components/iniciar-proceso/iniciar-proceso.component";
import {TareasComponent} from "./components/tareas/tareas.component";
import { LogoutComponent } from "./components/logout/logout.component";
import { AccesoComponent } from "./components/acceso/acceso.component";
import { AuditoriaProcesosComponent } from "./components/auditoria-procesos/auditoria-procesos.component";
import { RenderFormComponent } from "./components/render-form/render-form.component";
import { NotifyDataComponent } from "./components/notify-data/notify-data.component";
import { PermisosMenuComponent } from "./components/permisos-menu/permisos-menu.component";
import { FormRedirectComponent } from "./components/form-redirect/form-redirect.component";
import { DiagramComponent } from "./components/diagram/diagram.component";
import { PlantillasComponent } from "./components/plantillas/plantillas.component";
import { ConectoresComponent } from "./components/conectores/conectores.component";
import { TipoConectorComponent } from "./components/tipo-conector/tipo-conector.component";
import { SupersetReportComponent } from "./components/superset-report/superset-report.component";
import { DatatableBancoProcesosComponent } from "./components/datatable-banco-procesos/datatable-banco-procesos.component";import { ReporteriaAdminComponent } from './components/reporteria-admin/reporteria-admin.component';
import { ReporteriaVisorComponent } from './components/reporteria-visor/reporteria-visor.component';
const routes: Routes = [
  {path: '', redirectTo: 'login', pathMatch: 'full' },

  {path: 'login', component: LoginComponent },
  {
    path: "home",
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: "procesos", component: DatatableProcesosComponent},
      { path: "design-process", component: DiagramComponent},
      { path: "usuarios", component: UsuariosComponent },
      { path: "grupos", component: GrupoComponent },
      { path: "roles", component: RolComponent },
      { path: "formularios", component: DatatableFormulariosComponent },
      { path: "design-form", component: FormComponent },
      { path: "acceso", component: AccesoComponent },
      { path: "editar-formulario", component: FormEditComponent },
      { path: "iniciar-proceso", component: IniciarProcesoComponent },
      { path: "tareas", component: TareasComponent },
      { path: "logout", component: LogoutComponent },
      { path: "auditoria", component: AuditoriaProcesosComponent },
      { path: "formulario", component: RenderFormComponent },
      
      { path: "historial-process", component: DatatableHistorialComponent },
      { path: "usuarios-permitidos", component: NotifyDataComponent },
      { path: "permisos-menu", component: PermisosMenuComponent },
      { path: "plantillas", component: PlantillasComponent },
      { path: "conectores", component: ConectoresComponent },
      { path: "tipo-conectores", component: TipoConectorComponent },
      { path: "reports/:reportKey", component: SupersetReportComponent },
      { path: "banco", component: DatatableBancoProcesosComponent },
      { path: "reporteria-admin", component: ReporteriaAdminComponent },
      { path: "reporteria-visor", component: ReporteriaVisorComponent }
    ],
  },
  { path: "redirect", component: FormRedirectComponent },
  { path: '**', redirectTo: 'login', pathMatch: 'full' } 

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
